import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes =[
  {
    path: '/',
    name: 'Home',
    component: resolve => require(['@/pages/home/Home'], resolve)
  },
  {
    path: '/detail',
    name: 'Detail',
    component: resolve => require(['@/pages/detail/Detail'], resolve)
  },
  {
    path: '/detailxsc',
    name: 'Detailxsc',
    component: resolve => require(['@/pages/detail/Detailxsc'], resolve)
  },
  {
    path: '/infolist',
    name: 'Infolist',
    component: resolve => require(['@/pages/infolist/Infolist'], resolve)
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: resolve => require(['@/pages/login/Login'], resolve)
  // },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/pages/form/ActiveLogin'], resolve)
  },
  {
    path: '/forms1',
    component: resolve => require(['@/pages/form/ActiveStep1'], resolve)
  },
  {
    path: '/forms2',
    component: resolve => require(['@/pages/form/ActiveStep2'], resolve)
  },
  {
    path: '/forms3',
    component: resolve => require(['@/pages/form/ActiveStep3'], resolve)
  },
  {
    path: '/forms4',
    component: resolve => require(['@/pages/form/ActiveStep4'], resolve)
  },
  {
    path: '/office',
    component: resolve => require(['@/pages/officeMail/Officeindex'], resolve)
  },
  {
    path: '/officeadd',
    component: resolve => require(['@/pages/officeMail/OfficeAdd'], resolve)
  },
  {
    path: '/NotFound',
    component: resolve => require(['@/pages/notfound/NotFound'], resolve)
  }
]
// export default new Router({
//   routes: [
    
//   ],
//   scrollBehavior (to, from, savePosition) {
//     return { x: 0, y: 0 }
//   }
// })
const router =new Router({
  mode:'hash',//history模式不显示#
  routes ,
  base: "/" + document.location.pathname.split('/')[1] +  "/"  
  //base:"/WebSite/" 
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js